import * as jsApiLoader from "@googlemaps/js-api-loader"

let placesLibraryPromise: Promise<google.maps.PlacesLibrary> | null = null

export function loadGoogleMapsPlaces(): Promise<google.maps.PlacesLibrary> {
    if (placesLibraryPromise) {
        return placesLibraryPromise
    }

    const apiKey = process.env.GOOGLE_CLOUD_PLATFORM_API_KEY_FRONTEND

    if (!apiKey) {
        return Promise.reject(new Error("GOOGLE_CLOUD_PLATFORM_API_KEY_FRONTEND is not configured"))
    }

    jsApiLoader.setOptions({ key: apiKey, v: "weekly" })
    placesLibraryPromise = jsApiLoader.importLibrary("places")

    return placesLibraryPromise
}
